export default "__VITE_PUBLIC_ASSET__4e1d3f11__"